/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import {
  Component, Inject, Input, OnInit,
} from '@angular/core';
import { DisplayProps } from '../types';

@Component({
  selector: 'bulb-user-byline',
  templateUrl: './user-byline.component.html',
  styleUrls: ['./user-byline.component.scss'],
  standalone: false,
})
export class UserBylineComponent implements OnInit {
  public authorUrl: string;

  @Input() displayProps?: DisplayProps = {
    id: 'default-display-props',
    colorScheme: 'BLUE',
    subjectType: 'BULB_USER',
    displayName: 'Bulb User',
  };

  constructor(
    @Inject('$state') private $state,
    @Inject('BulbPresentationService') private bulbPresentationService,
  ) {
  }

  ngOnInit() {
    this.authorUrl = this.getAuthorHref();
  }

  private getAuthorHref(): string {
    return this.$state.href('author', { username: this.displayProps.username });
  }

  /**
   * Function that handles presentation mode when user clicks username inside the presentation mode.
   *
   */
  handlePresentationMode() {
    if (this.$state.$current.name === 'presentation_page') {
      this.bulbPresentationService.exitPresentation(true);
    }
  }
}
